import { useContext } from "react";
import DocumentDetail from "../../documents/document-detail/DocumentDetail";
import { AuthContext } from "../../../util/context";
import Dashboard from "../../dashboard/Dashboard";
import Login from "../../auth/Login";

export default function ViewDocumentPage() {
  let view;
  const { isAuthenticated, user, isUser } = useContext(AuthContext);

  const viewDocument =
    user?.job_role?.toLowerCase().includes("hod") ||
    user?.job_role?.toLowerCase() === "hop" ||
    user?.job_role?.toLowerCase() === "lawyer" ||
    user?.job_role?.toLowerCase() === "seed" ||
    user?.job_role?.toLowerCase() === "hr";

  if (viewDocument) {
    view = <DocumentDetail />;
  } else {
    view = <Dashboard />;
  }
  return <>{isAuthenticated && isUser ? view : <Login />}</>;
}
